import { ExamSessionDetails } from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import React from 'react';
import { Stepper } from '../../../../../../../../component/stepper/stepper';
import {
  CheckBoxSeverity,
  ColorfulCheckbox,
} from '../../../../../../../../component/ui/colorful-checkbox/colorful-checkbox';
import { Checkbox } from 'primereact/checkbox';
import { InputSwitch, InputSwitchChangeEvent } from 'primereact/inputswitch';
import './input-switch-style.css';
import globalProgramStore from '../../../../../../../../stores/program-store';
import globalCourseStore from '../../../../../../../../stores/global-course-store';
import { updateNotesCollectedOperation } from './operations/update-notes-collected-operation';

interface ExamSessionBottomStepperDatamodel {
  examSession: ExamSessionDetails | null;
  examId: number;
  setSessionDetails: (sessions: ExamSessionDetails[]) => any;
}

export const ExamSessionBottomStepper: React.FC<
  ExamSessionBottomStepperDatamodel
> = ({ examSession, examId, setSessionDetails }) => {
  const currentSession = examSession;

  const isClassedScheduled = currentSession?.classesSchedule.length > 0;

  const isProtectorsScheduled =
    !currentSession?.classesSchedule.some(
      (item) => item.protectors.length === 0,
    ) &&
    currentSession &&
    currentSession.classesSchedule.length > 0;

  const trueEnrollmentCount = currentSession?.studentsRegistrations.reduce(
    (count, student) => {
      return student.enrollment === true ? count + 1 : count;
    },
    0,
  );

  const trueClassRegistration = currentSession?.classesSchedule.reduce(
    (count, classSchedule) => {
      return count + classSchedule.enrollment.length;
    },
    0,
  );

  const isStudentRegister =
    trueEnrollmentCount === trueClassRegistration && trueEnrollmentCount > 0;

  const isStepOneCompleted =
    isClassedScheduled && isStudentRegister && isProtectorsScheduled;

  const isExamFinished =
    isStepOneCompleted && currentSession?.classesSchedule[0]?.endAt
      ? new Date(currentSession.classesSchedule[0].endAt).getTime() <
        new Date().getTime()
      : false;

  const isAllGradesCompleted =
    (isStepOneCompleted &&
      !currentSession?.classesSchedule.some((item) =>
        item.enrollment.some((enrollmentItem) => enrollmentItem.grade === null),
      )) ??
    false;

  const asd = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '16px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',

            alignItems: 'center',
            gap: '4px',
            backgroundColor: 'rgba(96, 165, 250, 0.8)',
            padding: '4px',
            borderRadius: '4px',
          }}
        >
          <ColorfulCheckbox
            onChange={() => {
              //
            }}
            severity={CheckBoxSeverity.WARNING}
            checked={isClassedScheduled}
          />
          <label style={{ color: 'white' }}>כיתות</label>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '4px',
            backgroundColor: 'rgba(96, 165, 250, 0.8)',
            padding: '4px',
            borderRadius: '4px',
          }}
        >
          <ColorfulCheckbox
            onChange={() => {
              //
            }}
            severity={CheckBoxSeverity.WARNING}
            checked={isStudentRegister}
          />{' '}
          <label style={{ color: 'white' }}>סטודנטים</label>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '4px',
            backgroundColor: 'rgba(96, 165, 250, 0.8)',
            padding: '4px',
            borderRadius: '4px',
          }}
        >
          <ColorfulCheckbox
            onChange={() => {
              //
            }}
            severity={CheckBoxSeverity.WARNING}
            checked={isProtectorsScheduled}
          />{' '}
          <label style={{ color: 'white' }}>משגיחים</label>
        </div>
      </div>
    );
  };

  const handleNotesHasBeenCollected = async (switchValue: boolean) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourse = globalCourseStore.getCurrentCourse();
    const examSessionId = examSession?.id;

    await updateNotesCollectedOperation(
      currentProgramId,
      currentCourse?.metadata.id,
      examId,
      examSessionId,

      switchValue,
      setSessionDetails,
    );
  };

  return (
    <div
      style={{
        paddingTop: '8px',
        backgroundColor: 'rgb(249, 250, 251)',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingBottom: '8px',
      }}
    >
      <Stepper
        items={[
          {
            isSelected: isStepOneCompleted,
            itemNumber: 1,
            text: 'שיבוצים',
            component: asd(),
          },
          {
            itemNumber: 2,
            text: 'ממתין לשאלון',
            isSelected: examSession?.files?.length > 0 ?? false,
          },
          {
            itemNumber: 3,
            text: 'ממתין לבחינה',
            isSelected: isStepOneCompleted,
          },
          {
            itemNumber: 4,
            text: 'הבחינה התחילה',
            isSelected:
              isStepOneCompleted && currentSession?.classesSchedule[0]?.startAt
                ? new Date(
                    currentSession.classesSchedule[0].startAt,
                  ).getTime() < new Date().getTime()
                : false,
          },
          {
            itemNumber: 5,
            text: 'הבחינה התבצעה',
            isSelected: isExamFinished,
          },
          {
            itemNumber: 6,
            text: 'מחברות נאספו לבדיקה',
            isSelected: examSession?.notesCollected ?? false,
            component: (
              <div className="switch-wrapper-green">
                <InputSwitch
                  checked={examSession?.notesCollected ?? false}
                  disabled={!isExamFinished}
                  tooltip={
                    !isExamFinished
                      ? 'ניתן לשנות מצב זה רק לאחר הבחינה'
                      : 'מחברות נאספו לבדיקה'
                  }
                  tooltipOptions={{
                    showOnDisabled: true,
                  }}
                  onChange={(event: InputSwitchChangeEvent) =>
                    handleNotesHasBeenCollected(event.value)
                  }
                />
              </div>
            ),
          },
          {
            itemNumber: 7,
            text: 'הוזנו ציונים',
            isSelected: isAllGradesCompleted,
            /*component: <Tag severity={'success'} value={'הסתיים בהצלחה'} />,*/
          },
          {
            itemNumber: 8,
            text: 'פורסמו ציונים',
            isSelected:
              (isStepOneCompleted && currentSession?.gradesApproval) ?? false,
            /*component: <Tag severity={'success'} value={'הסתיים בהצלחה'} />,*/
          },
        ]}
      />
    </div>
  );
};
